// source: tendermint/crypto/keys.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.tendermint.crypto.PublicKey', null, global);
goog.exportSymbol('proto.tendermint.crypto.PublicKey.SumCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tendermint.crypto.PublicKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tendermint.crypto.PublicKey.oneofGroups_);
};
goog.inherits(proto.tendermint.crypto.PublicKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tendermint.crypto.PublicKey.displayName = 'proto.tendermint.crypto.PublicKey';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tendermint.crypto.PublicKey.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.tendermint.crypto.PublicKey.SumCase = {
  SUM_NOT_SET: 0,
  ED25519: 1,
  SECP256K1: 2
};

/**
 * @return {proto.tendermint.crypto.PublicKey.SumCase}
 */
proto.tendermint.crypto.PublicKey.prototype.getSumCase = function() {
  return /** @type {proto.tendermint.crypto.PublicKey.SumCase} */(jspb.Message.computeOneofCase(this, proto.tendermint.crypto.PublicKey.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tendermint.crypto.PublicKey.prototype.toObject = function(opt_includeInstance) {
  return proto.tendermint.crypto.PublicKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tendermint.crypto.PublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tendermint.crypto.PublicKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    ed25519: msg.getEd25519_asB64(),
    secp256k1: msg.getSecp256k1_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tendermint.crypto.PublicKey}
 */
proto.tendermint.crypto.PublicKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tendermint.crypto.PublicKey;
  return proto.tendermint.crypto.PublicKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tendermint.crypto.PublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tendermint.crypto.PublicKey}
 */
proto.tendermint.crypto.PublicKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEd25519(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSecp256k1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tendermint.crypto.PublicKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tendermint.crypto.PublicKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tendermint.crypto.PublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tendermint.crypto.PublicKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes ed25519 = 1;
 * @return {!(string|Uint8Array)}
 */
proto.tendermint.crypto.PublicKey.prototype.getEd25519 = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes ed25519 = 1;
 * This is a type-conversion wrapper around `getEd25519()`
 * @return {string}
 */
proto.tendermint.crypto.PublicKey.prototype.getEd25519_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEd25519()));
};


/**
 * optional bytes ed25519 = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEd25519()`
 * @return {!Uint8Array}
 */
proto.tendermint.crypto.PublicKey.prototype.getEd25519_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEd25519()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tendermint.crypto.PublicKey} returns this
 */
proto.tendermint.crypto.PublicKey.prototype.setEd25519 = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.tendermint.crypto.PublicKey.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tendermint.crypto.PublicKey} returns this
 */
proto.tendermint.crypto.PublicKey.prototype.clearEd25519 = function() {
  return jspb.Message.setOneofField(this, 1, proto.tendermint.crypto.PublicKey.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tendermint.crypto.PublicKey.prototype.hasEd25519 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes secp256k1 = 2;
 * @return {!(string|Uint8Array)}
 */
proto.tendermint.crypto.PublicKey.prototype.getSecp256k1 = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes secp256k1 = 2;
 * This is a type-conversion wrapper around `getSecp256k1()`
 * @return {string}
 */
proto.tendermint.crypto.PublicKey.prototype.getSecp256k1_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSecp256k1()));
};


/**
 * optional bytes secp256k1 = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSecp256k1()`
 * @return {!Uint8Array}
 */
proto.tendermint.crypto.PublicKey.prototype.getSecp256k1_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSecp256k1()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.tendermint.crypto.PublicKey} returns this
 */
proto.tendermint.crypto.PublicKey.prototype.setSecp256k1 = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.tendermint.crypto.PublicKey.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tendermint.crypto.PublicKey} returns this
 */
proto.tendermint.crypto.PublicKey.prototype.clearSecp256k1 = function() {
  return jspb.Message.setOneofField(this, 2, proto.tendermint.crypto.PublicKey.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tendermint.crypto.PublicKey.prototype.hasSecp256k1 = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.tendermint.crypto);
